export default class PathCreationDto {

    constructor(name: string | null, type: number | null) {
        this.Name = name;
        this.Type = type;
    }

    Name: string | null;
    Type: number | null;
}